<template>
    <div id="html_source">
        <div id="header">
            <img class="tachikawa_logo" src="../../assets/img/logo.svg" alt="">
            <img class="myroom_logo" src="../../assets/img/myroomsimulation.svg" alt="">
        </div>
        <div id="main">
            <img class="room_img" :src="room_img" alt="">
            <ul>
                <li :key="meta.text" v-for="meta in all_meta">
                    <img :src="`${base_url}/curtain/repeat/${meta.prefix}/thumb/${meta.name}.jpg`" alt="">
                    <span>{{meta.text}}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
    import html2canvas from 'html2canvas'
    import CONST from "@/assets/js/const";

    export default {
        name: "DlSource",
        data: () => ({
            base_url: `${CONST.BASE_URL}item_image`,
        }),
        computed: {
            ...mapGetters('simulator', ['all_meta']),
            room_img: _this => document.querySelector('.konvajs-content canvas').toDataURL('image/png'),
        },
        mounted() {
            this.downloadImage();
        },
        methods: {
            ...mapMutations(['setIsCreatingImage']),
            async downloadImage() {
                const canvas = await html2canvas(document.querySelector('#html_source'));
                // document.body.appendChild(canvas);

                const link = document.createElement("a");
                link.href = canvas.toDataURL("image/png");
                link.download = "my_room_simulation.png";
                link.click();

                this.setIsCreatingImage(false);
            },
        },
    }
</script>

<style scoped lang="scss">
    @import "../../assets/css/define";
    #html_source {
        position: absolute;
        //top:0;
        //background: #ccc;
        left: -3000px;
        display: block;
        width: 1000px;
        height: 667px;
        //border: 1px solid;
        padding: 30px;
        #header {
            display: flex;
            justify-content: space-between;
            margin-bottom: 60px;
            .tachikawa_logo {
                height: 20px;
            }
            .myroom_logo {
                height: 30px;
                margin-right: 95px;
            }
        }
        #main {
            display: flex;
            justify-content: space-between;
            .room_img {
                max-width: 640px;
                max-height: 575px;
            }
            ul {
                margin: 0;
                width: 330px;
                padding-left: 30px;
                list-style-type: none;
                li {
                    display: flex;
                    img {
                        margin-top: 5px;
                        margin-right: 20px;
                        margin-bottom: 40px;
                        width: 40px;
                        height: 40px;
                    }
                    span {
                        word-break: keep-all;
                        font-feature-settings: normal !important;
                    }
                }
            }
        }
    }
</style>
